var WSEventType = /* @__PURE__ */ ((WSEventType2) => {
  WSEventType2["DEPOSIT_SUCCESS"] = "deposit-success";
  WSEventType2["BALANCE_CHANGED"] = "balance-changed";
  WSEventType2["TOKEN_CHANGE_EVENT"] = "token-change";
  WSEventType2["BLACKLIST_UPDATE"] = "blacklist-update";
  WSEventType2["REFERRAL_TOKEN_SETTINGS_CHANGE"] = "referral-token-settings-change";
  WSEventType2["SKINNER_BOX_TX_UPDATED"] = "skinner-box-updated";
  WSEventType2["COMPENSATION_UPDATED"] = "compensation-updated";
  WSEventType2["PLAY_SPIN_UPDATED"] = "play-spin-updated";
  WSEventType2["MEGA_SHARE_UPDATED"] = "mega-share-updated";
  WSEventType2["CASHBACK_UPDATED"] = "cashback-updated";
  WSEventType2["REFERRAL_COMMISSION_UPDATED"] = "referral-commission-updated";
  WSEventType2["WITHDRAWAL_CANCELLED"] = "withdrawal-cancelled";
  return WSEventType2;
})(WSEventType || {});
export {
  WSEventType
};
